// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FallbackScreen_wrapper__31BwY","button":"FallbackScreen_button__2AIwU"};